module.exports = __webpack_public_path__ + "img/logo2.d9368680.png";